import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  CardMedia,
  Input,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { ChangeEvent, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import EditText from "../../components/editText";

const AddEditBlog = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isAddBlog = location.pathname === "/manage-blogs-listings/add";

  const [blogImage, setBlogImage] = useState<string>("");
  const [authorImage, setAuthorImage] = useState<string>("");
  const [legal1, setLegal1] = useState<string>("");

  const categories = [
    "Technology",
    "Maintenance",
    "Reviews",
    "Environment",
    "News",
    "Tips"
  ];

  return (
    <>
      {/* PAGE TITLE */}
      <div className="main_title">
        <h1>{isAddBlog ? "Add" : "Edit"} Blog</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -{" "}
          <button onClick={() => navigate("/manage-blogs-listings")}>Blog Listings</button>{" "}
          - {isAddBlog ? "Add" : "Edit"} Blog
        </p>
      </div>

      <div className="form">

        <div className="cards">
          <div className="table_header mb_20">
            <h2>Blog Information</h2>
          </div>

          <div className="gap_p">
            {/* Blog Image Upload */}
            <div className="control_group w_100">
              <label>Blog Image</label>
              <div className="gap_p">
                <div className="w_25">
                  {blogImage ? (
                    <div className="upload_image no_radius v2">
                      <div className="upload_image_holder">
                        <figure>
                          <CardMedia component="img" image={blogImage} />
                        </figure>
                        <CloseIcon
                          className="remove_img"
                          onClick={() => setBlogImage("")}
                        />
                      </div>
                    </div>
                  ) : (
                    <label className="upload_image no_radius v2">
                      <Input
                        sx={{ display: "none" }}
                        type="file"
                        inputProps={{ accept: "image/*" }}
                        onChange={(event: ChangeEvent<HTMLInputElement>) => {
                          const files = event.target.files;
                          if (files && files[0]) {
                            setBlogImage(URL.createObjectURL(files[0]));
                          }
                        }}
                      />
                      <span className="upload_image_holder">
                        <figure className="add_img">
                          <img
                            src="/static/images/placeholder.png"
                            alt=""
                          />
                          <span className="upload_img_icon">
                            <img
                              src="/static/images/edit2_icon.svg"
                              alt=""
                            />
                          </span>
                        </figure>
                      </span>
                    </label>
                  )}
                </div>
              </div>
            </div>

            {/* Blog Title */}
            <div className="control_group w_50">
              <label>Blog Title</label>
              <TextField placeholder="Enter Blog Title" hiddenLabel fullWidth />
            </div>

            {/* Blog Category */}
            <div className="control_group w_50">
              <label>Blog Category</label>
              <Select fullWidth hiddenLabel defaultValue="default">
                <MenuItem value="default" disabled>Select Category</MenuItem>
                {categories.map((cat) => (
                  <MenuItem key={cat} value={cat}>{cat}</MenuItem>
                ))}
              </Select>
            </div>

            {/* Blog Description */}
            <div className="control_group w_100">
              <label>Blog Description</label>
              <EditText content={legal1} setContent={setLegal1} />
            </div>
          </div>
        </div>

        <div className="cards">
          <div className="table_header mb_20">
            <h2>Author Detail</h2>
          </div>

          <div className="gap_p">
            {/* Author Image Upload */}
            <div className="control_group w_100">
              <label>Author Image</label>
              <div className="gap_p">
                <div className="w_25">
                  {authorImage ? (
                    <div className="upload_image">
                      <div className="upload_image_holder">
                        <figure>
                          <CardMedia component="img" image={authorImage} />
                        </figure>
                        <CloseIcon
                          className="remove_img"
                          onClick={() => setAuthorImage("")}
                        />
                      </div>
                    </div>
                  ) : (
                    <label className="upload_image">
                      <Input
                        sx={{ display: "none" }}
                        type="file"
                        inputProps={{ accept: "image/*" }}
                        onChange={(event: ChangeEvent<HTMLInputElement>) => {
                          const files = event.target.files;
                          if (files && files[0]) {
                            setAuthorImage(URL.createObjectURL(files[0]));
                          }
                        }}
                      />
                      <span className="upload_image_holder">
                        <figure className="add_img">
                          <img
                            src="/static/images/placeholder.png"
                            alt=""
                          />
                          <span className="upload_img_icon">
                            <img
                              src="/static/images/edit2_icon.svg"
                              alt=""
                            />
                          </span>
                        </figure>
                      </span>
                    </label>
                  )}
                </div>
              </div>
            </div>

            {/* Author Name */}
            <div className="control_group w_50">
              <label>Author Name</label>
              <TextField placeholder="Enter Author Name" hiddenLabel fullWidth />
            </div>
          </div>
        </div>

        {/* SAVE BUTTON */}
        <div className="form_btn">
          <Button className="btn btn_primary">Save</Button>
        </div>
      </div>
    </>
  );
};

export default AddEditBlog;
